module.exports = __webpack_public_path__ + "static/img/1.77b1ba3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/1.png
// module id = DdK4
// module chunks = 0